export default "__VITE_ASSET__Bmhfi6aK__"